<template>
  <div class="mall-help">
    <div class="mall-help__shell">
      <header class="mall-help__head">
        <p class="mall-help__eyebrow">{{ MALL_NAME }}</p>
        <h1>고객센터</h1>
        <p>주문, 결제, 배송, 환불 기준을 한곳에서 확인합니다.</p>
      </header>

      <div class="mall-help__layout">
        <nav class="mall-help__nav" aria-label="고객센터 정책">
          <router-link
            v-for="topic in MALL_HELP_TOPICS"
            :key="topic.id"
            :to="mallHelpPath(topic.id)"
            class="mall-help__nav-item"
            :class="{ 'is-active': topic.id === current.id }"
          >
            {{ topic.label }}
          </router-link>
          <router-link to="/mall/mypage/consults" class="mall-help__nav-item">
            문의 내역
          </router-link>
        </nav>

        <article class="mall-help__doc">
          <h2>{{ current.label }}</h2>
          <p class="mall-help__summary">{{ current.summary }}</p>
          <section v-for="section in current.sections" :key="section.title" class="mall-help__section">
            <h3>{{ section.title }}</h3>
            <p>{{ section.body }}</p>
          </section>
        </article>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { MALL_NAME } from '@/constants/mall'
import { MALL_HELP_TOPICS, findMallHelpTopic, mallHelpPath } from '@/constants/mallHelp'

const route = useRoute()
const current = computed(() => findMallHelpTopic(String(route.params.topic || 'guide')))
</script>

<style lang="scss" src="./MallHelpPage.scss"></style>
